import React from 'react';
import { PromoBanner } from '@/shared/ui/promo-banner';

interface StatusBannerProps {
  bannerAssets?: {
    default?: string;
    mobile?: string;
  } | null;
}

export const StatusBanner = ({ bannerAssets }: StatusBannerProps) => {
  return (
    <PromoBanner bg={bannerAssets?.default} mobile={bannerAssets?.mobile} />
  );
};
